import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

/**
 * Copies text to the clipboard and reports the outcome to the user.
 */
@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  constructor(private readonly toastrService: ToastrService) {}

  copy(text: string, successMessage?: string): void {
    this.writeText(text).then(
      () =>
        this.toastrService.success(
          successMessage ?? $localize`Copié avec succès`
        ),
      () =>
        this.toastrService.error(
          $localize`Impossible de copier dans le presse-papiers`
        )
    );
  }

  private writeText(text: string): Promise<void> {
    // navigator.clipboard is undefined outside of a secure context (plain http on a remote host)
    if (navigator.clipboard?.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return this.legacyWriteText(text);
  }

  private legacyWriteText(text: string): Promise<void> {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);

    try {
      textArea.select();
      return document.execCommand('copy')
        ? Promise.resolve()
        : Promise.reject();
    } catch {
      return Promise.reject();
    } finally {
      document.body.removeChild(textArea);
    }
  }
}
